import { Routes } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';

import { ClaimLandingComponent } from './claim/claim-landing/claim-landing.component';
import { BusinessGuard } from './guard/business.guard';
import { PolicyLandingComponent } from './policy/policy-landing/policy-landing.component';

export function param(params: any): Observable<string> {
  // auto, prop, and umbrella just want the param as breadcrumb.
  return observableOf(params.id);
}

export const BusinessPolicyRoutes: Routes = [
  {
    path: 'policies',
    data: {
      breadcrumb: 'Policies'
    },
    children: [{ path: '', component: PolicyLandingComponent, data: { breadcrumb: false } }]
  }
];

export const BusinessClaimRoutes: Routes = [
  {
    path: 'claims',
    data: {
      breadcrumb: 'Claims'
    },
    children: [{ path: '', component: ClaimLandingComponent, data: { breadcrumb: false } }]
  }
];

export const BusinessRoutes: Routes = [
  {
    path: 'business',
    data: {
      breadcrumb: 'Business'
    },
    canActivate: [BusinessGuard],
    children: [
      { path: '', redirectTo: '/overview', pathMatch: 'full' },
      ...BusinessPolicyRoutes,
      ...BusinessClaimRoutes
    ]
  }
];

export const BusinessGuards = [BusinessGuard];
